module.exports = __webpack_public_path__ + "static/media/personal.76c57faa.png";